import React, { useRef } from "react";

import Link from "@whoppah/next/link";
import { useTranslation } from "next-i18next";

import { useAuth } from "@/auth";
import { ACCOUNT_DASHBOARD_ROUTE } from "@/common/static/routes.static";
import HeaderAccountAvatar from "@/components/Header/HeaderAccountAvatar";
import { useHeaderAccountMobileData } from "@/components/Header/hooks/useHeaderAccountMobileData";
import { MegaMenuMobilePanel } from "@/components/mega-menu/mobile/MegaMenuMobilePanel";
import NoSSR from "@mpth/react-no-ssr";
import { ProfileOutlined as ProfileOutlinedIcon } from "@whoppah/icons/24/ProfileOutlined";

export const HeaderAccountMobile = () => {
  const { t } = useTranslation();
  const { data } = useHeaderAccountMobileData();
  const { isLoggedIn } = useAuth();

  const menuTriggerRef = useRef<HTMLButtonElement>(null);

  const handleClose = () => {
    if (menuTriggerRef.current) {
      menuTriggerRef.current.click();
    }
  };

  if (isLoggedIn) {
    // Signed in: same avatar as desktop, straight to the account area
    // (the hamburger keeps the full account menu).
    return (
      <NoSSR>
        <Link
          href={ACCOUNT_DASHBOARD_ROUTE}
          prefetch={false}
          aria-label={t("header:nav-account")}
          className="px-2"
        >
          <HeaderAccountAvatar />
        </Link>
      </NoSSR>
    );
  }

  return (
    <NoSSR>
      <MegaMenuMobilePanel
        trigger={
          <button
            ref={menuTriggerRef}
            type="button"
            className="px-2"
            aria-label={data.label || t("header:nav-account")}
          >
            <ProfileOutlinedIcon />
          </button>
        }
        title={data.label}
        items={data.items}
        onClose={handleClose}
      />
    </NoSSR>
  );
};
